// extracted by mini-css-extract-plugin
export default {"header":"hero-header-module--header--FJxXp","wave":"hero-header-module--wave--N387i","shapeBackground":"hero-header-module--shapeBackground--JDDD8"};